module.exports = __webpack_public_path__ + "img/db-1.818fffb4.png";